import BaseService from "./BaseService";

class CertificatesService {
    static async getCertificates(id, token) {
        try {
            return await BaseService.get(`certificates/${id}`, token);
        }
        catch (error) {
            console.error("Erro ao buscar certificados!", error);
        }
    }
}

export default CertificatesService;